import FormTemplate from "@Common/FormTemplate";
import OfferForm from "@Common/OfferForm";
import { OfferLightLabel } from "@Common/OfferLight";
import { isLightOffer, getLightOfferCover } from "@Common/OfferLight/helpers.js";
import { getSqlServerGuidHash, sendMetric, randomNumber, getWhatId, clearParamWithoutRerender, getAbTestMetrika, fixOrphans } from "@utils";
import dayjs from "dayjs";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";
import { useState, useEffect } from "react";

import Timer from "../../../Modal/PromoModal/Default/Timer";

import Arrow from "../../Default/img/arrow_black.svg";
import copyArrowBtnDark from "../../Default/img/arrow_btn.svg";
import copyDark from "../../Default/img/copy_dark.svg";
import copyGrey from "../../Default/img/copy_grey.svg";
import prize from "../../Default/ListItemAccordion/Default/img/gift_icon.gif";
import times from "../../Default/ListItemAccordion/Default/img/times.svg";

import "../../Default/ListItemAccordion/Default/style.scss";
import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const ListItemAccordion = inject("mainStore")(
    observer(({ mainStore, item, isAccordionOpen, setIsAccordionOpen, id, handleClick = () => {}, type = false, typeLabel = "", title = "", cover = "" }) => {
        const abTest = computed(() => mainStore.getMainStore("abTest")).get();
        const abTestMetika = computed(() => mainStore.getMainStore("abTestMetika")).get();
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const wdm = mainStore.getMainStore("codeWdm");
        const wd_mc = mainStore.getMainStore("codeWdMc");

        const [number, setNumber] = useState(5942);
        const [stateAnswer, setStateAnswer] = useState(0);
        const [open, setOpen] = useState(false);
        const [copyText, setCopyText] = useState(false);
        const [time, setTime] = useState("10:03");
        const [percentNumber, setPercentNumber] = useState(10);
        const [openDisclaimer, setOpenDisclaimer] = useState(false);
        const showOfferLight = isLightOffer(item);

        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const isAbTestMetrika = getAbTestMetrika(abTest, item?._id);

        const termsOfUse =
            item && item.offerDetail && item.offerDetail?.termsOfUse ? item.offerDetail?.termsOfUse.replace(/{{dateEnd}}/gim, dayjs(item.dateEnd).format("DD.MM.YYYY")).replace(/{{dateStart}}/gim, dayjs(item.dateStart).format("DD.MM.YYYY")) : "";

        useEffect(() => {
            if (isAccordionOpen._id === item._id) {
                let el = document.getElementById(`${isAccordionOpen._id}`);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }
        }, [isAccordionOpen]);

        useEffect(() => {
            let body = document.body;
            if (body && openDisclaimer) {
                body.style.overflow = "hidden";
                body.style["touch-action"] = "none";
                body.style["-webkit-overflow-scrolling"] = "none";
                body.style["overscroll-behavior"] = "none";
                body.style.width = "100%";
            } else {
                body.style = {};
            }
        }, [openDisclaimer]);

        useEffect(() => {
            if (localStorage.getItem(item._id)) {
                setNumber(parseInt(localStorage.getItem(item._id)));
                let timeHour = randomNumber(0, dayjs().subtract(2, "hour").format("HH"));
                let timeMinutes = randomNumber(10, 59);

                setTime(`${timeHour < 10 ? `0${timeHour}` : `${timeHour}`}:${timeMinutes}`);
            } else {
                let num = randomNumber(5000, 25000);
                let timeHour = randomNumber(0, dayjs().subtract(2, "hour").format("HH"));
                let timeMinutes = randomNumber(10, 59);

                setTime(`${timeHour < 10 ? `0${timeHour}` : `${timeHour}`}:${timeMinutes}`);

                localStorage.setItem(item._id, num);
                setNumber(num);
            }
        }, []);

        const handleOpen = () => {
            setOpen(!open);

            if (!open) {
                sendMetric(`click_offer_details`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: item._id,
                    params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                    params4: item?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: `${what_id}`,
                });
            }
        };

        const handleCopy = (e) => {
            e.stopPropagation();
            e.preventDefault();

            sendMetric(`click_offer_accepted_copy_code`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: `${what_id}`,
            });

            navigator.clipboard.writeText(item.promoCode).then(() => {
                setCopyText("Скопирован в буфер");
                setTimeout(() => {
                    setCopyText(false);
                }, 1000);
            });
        };

        const clickBtnCopy = (e) => {
            e.stopPropagation();
            e.preventDefault();

            navigator.clipboard.writeText(item.promoCode).then(() => {
                setTimeout(() => {
                    if (!localStorage.getItem("first_click_offer_go_to_site")) {
                        sendMetric(`first_click_offer_go_to_site`, {
                            params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                            params2: item._id,
                            params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                            params4: item?.code,
                            params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                            params7: null,
                            params8: `${what_id}`,
                        });

                        localStorage.setItem("first_click_offer_go_to_site", true);
                    }

                    sendMetric(`click_offer_accepted_copy_code_go_to_site`, {
                        params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                        params2: item._id,
                        params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                        params4: item?.code,
                        params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                        params7: null,
                        params8: `${what_id}`,
                    });

                    if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                        window.risMetrika.reachgoal_ch({
                            event: "click_offer_accepted_copy_code_go_to_site",
                            siteId: what_id, //'id витрины',
                            offerId: item?._id, //'id оффера'
                            variantCode: item?._ab_code, //'в оффере новый ключ _ab_code',
                            position: item?.positionIdx, //'Позиция оффера на витрине, не путать с сортировкой!!!' ,
                            sort: item?.sortNum, //'Сортировка оффера на витрине!!!' ,
                            session_uuid: localStorage.getItem("_r_p_s"),
                            widget_code: wdCd ? wdCd : "",
                            ml_traffic_mode: wdm ? wdm : "",
                            ml_model_code: wd_mc ? wd_mc : "",
                        });
                    }

                    const hrefOut = item && item.activationLink ? item.activationLink : false;

                    if (hrefOut) {
                        const a = document.createElement("a");
                        a.href = hrefOut;
                        a.target = "_blank";
                        a.click();
                        a.remove();
                    }
                }, 500);
            });
        };

        const clickBtn = (e) => {
            e.stopPropagation();
            e.preventDefault();
            if (!localStorage.getItem("first_click_offer_go_to_site")) {
                sendMetric(`first_click_offer_go_to_site`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: item._id,
                    params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                    params4: item?.code,
                    params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                    params7: null,
                    params8: `${what_id}`,
                });
                localStorage.setItem("first_click_offer_go_to_site", true);
            }

            sendMetric(`click_offer_accepted_go_to_site`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: `${what_id}`,
            });
            const hrefOut = item && item.activationLink ? item.activationLink : false;

            if (hrefOut) {
                const a = document.createElement("a");
                a.href = hrefOut;
                a.target = "_blank";
                a.click();
                a.remove();
            }
        };

        const handleInstruction = () => {
            sendMetric("click_instruction_offer", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: `Клик на инструкцию по активации"`,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?._id,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const handleClickGhost = () => {
            setIsAccordionOpen(false);
            clearParamWithoutRerender(["id", "code"]);

            sendMetric("click_offer_button_ghost_exit", {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: item._id,
                params3: getSqlServerGuidHash(item.code, item.vendor?._id),
                params4: item?.code,
                params6: isAbTestMetrika ? `${isAbTestMetrika}` : null,
                params7: null,
                params8: what_id,
            });
        };

        const closeAccordionWithClear = () => {
            setIsAccordionOpen(false);
            clearParamWithoutRerender(["id", "code"]);
        };

        return (
            <div className={`ab-4409-v3 list-item__accordion ${type ? type : ""} ${showOfferLight ? "offer-light" : ""} ${type === "special" ? "offer-special" : ""}`} id={item._id}>
                <div
                    className="list-item__accordion__content"
                    onClick={() => {
                        handleClick();
                        setStateAnswer(0);
                        setOpenDisclaimer(false);
                    }}
                >
                    <div className="list-item__accordion__logo">
                        <img alt={`logo_mobile`} className={`logo_mobile`} src={getLightOfferCover(item, cover, true)} />
                        <div className="list-item__accordion__title-container">
                            <span className={`list-item__accordion__title ${isAccordionOpen._id === item._id ? "big" : ""}`} dangerouslySetInnerHTML={{ __html: fixOrphans(title) }} />
                        </div>
                    </div>

                    {showOfferLight ? <OfferLightLabel /> : type === "hit" ? <span className="ab-4409-badge">new</span> : type === "special" ? <span className="list-item__accordion__hit-label_block special">{typeLabel}</span> : null}

                    {isAccordionOpen._id === item._id ? null : item.disclaimer ? (
                        <div
                            className={`list-item__btn btn disclaimer`}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setOpenDisclaimer(!openDisclaimer);
                            }}
                        >
                            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.668 25.6666C20.2954 25.6666 25.668 20.294 25.668 13.6666C25.668 7.03921 20.2954 1.66663 13.668 1.66663C7.04055 1.66663 1.66797 7.03921 1.66797 13.6666C1.66797 20.294 7.04055 25.6666 13.668 25.6666Z"
                                    stroke="#B1BAD4"
                                    strokeWidth="1.77333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path d="M13.668 18.4666V13.6666M13.668 8.86658H13.68" stroke={`#B1BAD4`} strokeWidth="1.77333" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            {openDisclaimer ? (
                                <div className="disclaimer__background">
                                    <div className="disclaimer__block">
                                        <div className="close__block">
                                            <img src={times} className="close__block-icon" />
                                        </div>
                                        <span>{item.offerDetail.ordRisPromo}</span>
                                        <span dangerouslySetInnerHTML={{ __html: item.disclaimer }}></span>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    ) : (
                        <div className={`list-item__btn btn`}>
                            <svg id="svg" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 28V16M16 9.33333H10.6C6.90668 9.33333 6.68002 4 10.6 4C14.8 4 16 9.33333 16 9.33333ZM16 9.33333H21.4C25.2614 9.33333 25.2614 4 21.4 4C17.2 4 16 9.33333 16 9.33333Z"
                                    stroke={"#B1BAD4"}
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M26.6667 16.0002V25.3335C26.6667 26.0407 26.3857 26.719 25.8856 27.2191C25.3855 27.7192 24.7072 28.0002 24 28.0002H8C7.29276 28.0002 6.61448 27.7192 6.11438 27.2191C5.61428 26.719 5.33333 26.0407 5.33333 25.3335V16.0002M28 16.0002V12.0002C28 11.2929 27.719 10.6146 27.219 10.1145C26.7189 9.61445 26.0406 9.3335 25.3333 9.3335H6.66667C5.95942 9.3335 5.28115 9.61445 4.78105 10.1145C4.28095 10.6146 4 11.2929 4 12.0002V16.0002H28Z"
                                    stroke={"#B1BAD4"}
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    )}
                </div>

                {isAccordionOpen._id === item._id ? (
                    item.promoCode ? (
                        item.ghostOffer ? (
                            <div className={`content__promo`}>
                                {/* <div className={`content__promo_desc`}>
                                    Сегодня это предложение забрали{" "}
                                    <span>
                                        {number.toLocaleString()} человек{pluralForm(number, ["", "а", ""])}
                                    </span>
                                </div> */}

                                <div className="content__text">
                                    <span className="title">
                                        {item?.ghostOfferConfig && item.ghostOfferConfig.textAnswer ? item.ghostOfferConfig.textAnswer : "Как только предложение станет доступным, мы направим уведомление  на указанную Вами почту "}
                                    </span>
                                    <div className={`content__promo_button-close`} onClick={() => handleClickGhost()}>
                                        Выбрать другое предложение
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className={`content__promo`}>
                                {/* <div className={`content__promo_desc`}>
                                    Сегодня это предложение забрали{" "}
                                    <span>
                                        {number.toLocaleString()} человек{pluralForm(number, ["", "а", ""])}
                                    </span>
                                </div> */}

                                <div className="offer__progressbar">
                                    <div className="offer__progressbar-header">
                                        <img alt="offer__progressbar-header" src={prize} />
                                        <span className="offer__progressbar-text">Активируйте предложение!</span>
                                        <span className="offer__progressbar-value" style={{ color: "#19B677" }}>
                                            {100}%
                                        </span>
                                    </div>
                                    <div className="offer__progressbar-line">
                                        <div className="line__filling" style={{ width: `100%` }}></div>
                                    </div>
                                </div>

                                {item?.offerType && !["partnerlink", "leads"].includes(item.offerType) ? (
                                    <div className={`content__promo_code ${copyText ? "copy" : ""}`} onClick={(e) => handleCopy(e)}>
                                        {copyText ? `${copyText}` : `${item.promoCode}`}
                                        <img alt="content__promo_code" src={copyText ? copyGrey : copyDark} />
                                    </div>
                                ) : null}

                                {item.offerType !== "leads" ? (
                                    <div className="content__promo_copy" id="button_copy" onClick={item?.offerType !== "partnerlink" ? (e) => clickBtnCopy(e) : (e) => clickBtn(e)}>
                                        {item?.offerType !== "partnerlink" && item._id !== "662b6b30d07bd4eb3685f19b" && item._id !== "65af6c1623f7b941440758ec" ? "Скопировать и перейти на сайт" : "Перейти на сайт"}
                                        <img alt="content__promo_copy" src={copyArrowBtnDark} width={21} />
                                    </div>
                                ) : (
                                    <span className="content__promo-text">
                                        <span>Спасибо за вашу заявку!</span>
                                        <span>Наш менеджер скоро с вами свяжется</span>
                                    </span>
                                )}
                                {item.offerType === "leads" ? null : (
                                    <div className="content__promo_timer">
                                        <span>Успейте активировать:</span>
                                        <Timer endDate={dayjs().local()} />
                                    </div>
                                )}

                                {!item.activationLink.length ? (
                                    <div className={`content__promo_button-close`} onClick={closeAccordionWithClear}>
                                        Выбрать еще предложения
                                    </div>
                                ) : null}
                                {item?.offerDetail?.miniDisc ? <div className="content__promo_instructions" onClick={handleInstruction} dangerouslySetInnerHTML={{ __html: item?.offerDetail.miniDisc }}></div> : null}
                                <div className="content__promo_button" id="close_accordion" onClick={closeAccordionWithClear}>
                                    <span>Скрыть предложение</span> <img alt="content__promo_button" src={Arrow} />
                                </div>
                            </div>
                        )
                    ) : (
                        <div className="content__offer">
                            {/* <div className={`content__offer_desc`}>
                                Сегодня это предложение забрали{" "}
                                <span>
                                    {number.toLocaleString()} человек{pluralForm(number, ["", "а", ""])}
                                </span>
                            </div> */}

                            {isAccordionOpen.formTemplate && stateAnswer < isAccordionOpen.formTemplate?.length ? (
                                <div className="form">
                                    {isAccordionOpen.formTemplate?.map((el, index) =>
                                        stateAnswer === index ? (
                                            <FormTemplate
                                                type={el.restrictionType}
                                                item={el}
                                                key={index}
                                                stateAnswer={stateAnswer}
                                                setStateAnswer={setStateAnswer}
                                                formTemplate={isAccordionOpen.formTemplate}
                                                offerId={item._id}
                                                surveyId={isAccordionOpen.surveyId}
                                                vendorId={item.vendor._id}
                                                index={index}
                                                promo={item}
                                                setIsAccordionOpen={setIsAccordionOpen}
                                                id={id}
                                                setPercentNumber={setPercentNumber}
                                                percentNumber={percentNumber}
                                                time={time}
                                                number={number}
                                            />
                                        ) : null,
                                    )}
                                </div>
                            ) : (
                                <OfferForm offerItem={isAccordionOpen} setIsAccordionOpen={setIsAccordionOpen} setPercentNumber={setPercentNumber} percentNumber={percentNumber} time={time} number={number} />
                            )}

                            {item.ghostOffer ? null : <div className="content__offer_description" dangerouslySetInnerHTML={{ __html: item.description }}></div>}

                            {item.ghostOffer ? null : (
                                <div className="content__offer_details_btn" onClick={(e) => handleOpen(e)}>
                                    <span>{open ? "Скрыть" : "Подробное описание"}</span>
                                    <img alt="content__offer_details_btn" src={Arrow} style={!open ? { transform: "rotate(180deg)" } : {}} />
                                </div>
                            )}

                            {item.ghostOffer ? null : open ? (
                                <div className={`content__offer_info ${open ? "open" : ""}`}>
                                    <div className={`content__offer_info_activate `} dangerouslySetInnerHTML={{ __html: item?.offerDetail?.howToActivate || "" }}></div>
                                    <div className={`content__offer_info_details `}>
                                        <div className="container__all-conditions_text" dangerouslySetInnerHTML={{ __html: termsOfUse }}></div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    )
                ) : null}
            </div>
        );
    }),
);

export default ListItemAccordion;
